import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import Swal from "sweetalert2";
import { privateRequest } from "../commonApi/CommonApi";
import { Helmet } from "react-helmet";

function ServiceType() {
  const [serviceT, setServiceT] = useState([]);
  const [parentcat, setParentCat] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [Name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [deleteService, setDeleteService] = useState([]);
  const [editItemId, setEditItemId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  console.log("Name", Name);
  const getServiceType = async () => {
    try {
      const response = await privateRequest.get(
        `ServiceType/ServiceTypeByStatus`
      );
      setServiceT(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/Parentcategory`
      );
      setParentCat(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deleteServic = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ServiceType/DeleteServiceType/${_id}`
        );
        console.log("DELETE Response:", response);

        setDeleteService(deleteService.filter((item) => item._id !== _id));
        getServiceType();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };
  const handleServiceTypeSubmit = async (event) => {
    event.preventDefault();
    if (!Name) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "please fill name",
      });
      return;
    }
    if (!selectedGroup) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "please select parent category",
      });
      return;
    }
    try {
      const formData = {
        Name: Name,
        PCName: selectedGroup.map((group) => group.value),
        status: status,
      };

      if (editItemId) {
        // Update existing item
        await privateRequest.put(
          `ServiceType/UpdateServiceType/${editItemId}`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Service Type updated successfully!",
        });
      } else {
        // Add new item
        await privateRequest.post(`ServiceType/AddServiceType`, formData);
      }

      getServiceType();

      setSelectedGroup([]);
      setShowModal(false);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: editItemId
          ? "Service Type updated successfully!"
          : "Service Type added successfully!",
      });
      setName("");
      setSelectedGroup([]);
      setStatus("");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message,
      });
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getServiceType();
    getParentCategory();
  }, []);

  return (
    <>
      {serviceT?.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Service Type</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      onClick={() => {
                        setShowModal(true);

                        setEditItemId("");
                        setName("");
                        setSelectedGroup("");
                        setStatus("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">Type</th>
                            <th scope="col">P. Cat</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {serviceT && serviceT.length > 0 ? (
                            serviceT.map((item, index) => (
                              <tr key={index}>
                                <td className="align-center">{index + 1}</td>
                                <td className="align-center">{item?.Name}</td>
                                <td className="align-center">
                                  {(item?.PCName || []).map((category, i) => (
                                    <span
                                      key={i}
                                      className="badge badge-primary mr-2"
                                    >
                                      {category.PCName}
                                    </span>
                                  ))}
                                </td>
                                <td className="align-center">
                                  <span
                                    className={`badge ${
                                      item.status === "0"
                                        ? "badge-danger"
                                        : "badge-primary"
                                    }`}
                                  >
                                    {item.status === "1"
                                      ? "Active"
                                      : "Inactive"}
                                  </span>
                                </td>
                                <td className="align-center">
                                  <p className="mb-0">
                                    {item?.createdBy?.name}
                                  </p>
                                  <p className="mb-0">
                                    {new Date(
                                      item.createdAt
                                    ).toLocaleDateString("en-US", {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    })}
                                  </p>
                                </td>
                                <td className="align-center">
                                  <div className="btn-group">
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => {
                                        setEditItemId(item._id);
                                        setName(item.Name);
                                        setSelectedGroup(
                                          item.PCName.map((category) => ({
                                            value: category._id,
                                            label: category.PCName,
                                          }))
                                        );
                                        setStatus(item.status);
                                        setShowModal(true);
                                      }}
                                      data-toggle="modal"
                                      data-target="#addAreaModal"
                                    >
                                      <i className="fa fa-edit"></i>
                                    </button>
                                    <button
                                      className="btn btn-danger btn-sm"
                                      onClick={() => deleteServic(item._id)}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="childModal"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Service Type
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleServiceTypeSubmit}>
                <div className="form-group">
                  <label className="mb-0">Service Type</label>
                  <input
                    type="text"
                    id="inputgroupName"
                    className="form-control"
                    placeholder="Service Type"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0 ">Parent Category</label>
                  <Select
                    isMulti
                    options={parentcat.map((group) => ({
                      value: group._id,
                      label: group.PCName,
                    }))}
                    onChange={(selectedOptions) =>
                      setSelectedGroup(selectedOptions)
                    }
                    value={selectedGroup}
                  />
                </div>

                <div className="form-group">
                  <label className="mb-0">Status</label>
                  <select
                    className="form-control"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <button type="submit" className="btn btn-primary">
                    {editItemId ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default ServiceType;
